export default {
  factoryCollab:{
    publishUnconfirmed:'发布结果尚未确认，请保持本次信息并重试；系统将核对同一请求，避免重复发布。',
    email:'联系人邮箱',emailOptional:'联系人邮箱（选填）',emailMissing:'尚未填写',emailInvalid:'请输入有效邮箱，或留空。',editEmail:'修改邮箱',emailRequired:'请为所选联系人维护有效邮箱后发布邮件提醒，或明确选择仅发布到平台。',emailUpdateHelp:'修改邮箱不会自动发送邮件，也不会重发已有提醒。',
    publishAndNotify:'发布并通知工厂',publishOnly:'仅发布到供应商平台',publishOnlyChoice:'仅发布到供应商平台，暂不发送邮件',publishOnlyHelp:'资料发布后工厂可登录查看；本次不会发送邮件提醒。',publishSucceeded:'已发布到供应商平台',publishedAt:'发布时间',portalLink:'供应商平台链接',copyPortalLink:'复制平台链接',publishStorageUnavailable:'无法保存本次发布请求，请允许当前页面使用会话存储后重试。',publishPendingConflict:"存在多笔结果待核对的发布请求，请先核对已发送记录后再发布。",
    mailReminder:'邮件提醒',mailNotRequested:'未请求邮件提醒',mailUnavailable:'邮件服务未启用或未配置。请明确选择仅发布到供应商平台，或联系管理员配置。',mailEmailRequired:'请先维护有效的联系人邮箱。',publishConflict:'本次发布请求内容已变化，请重新核对。',mailChanged:'提醒状态已变化，请刷新后重试。',mailUnknown:'邮件投递结果不确定，请先人工核对。',mailRecipientChanged:'联系人邮箱已变化，请核对后重新发布。',mailInvalidLink:'供应商平台公开地址配置无效，请联系管理员。',mailUnknownHelp:'邮件投递结果未知，请先人工核对，避免重复发送。平台资料已发布。',mailFailedHelp:'邮件提醒失败，平台资料仍可查看。请在已发送资料中核对后重试。',mailDeliveryHelp:'邮件投递状态不代表工厂已读，请以工厂回复为准。',sendMail:'补发邮件提醒',retryMail:'重试邮件提醒',mailNotifyConfirm:'将向 {email} 发送本次资料的邮件提醒，是否继续？',
    mailStates:{PENDING:'等待发送',SENDING:'发送中',SENT:'邮件已提交投递',FAILED:'发送失败',UNKNOWN:'投递结果未知',CANCELLED:'已取消'},
    replyStatus: '确认状态',
    startReview: '去确认',
    viewReply: '查看回复',
    originalOrderTotal: '原订货数量',
    quantityDifference: '数量差额',
    quantityDifferenceReview: '可供数量已调整，待内部核对。正式订货数量保持原值。',
    documentReview: '工艺资料核对',
    documentReviewed: '资料无误',
    documentChangesNeeded: '资料需修改',
    replyNote: '补充说明',
    submitReply: '提交工厂回复',
    pieceUnit: '件',
    loginHeadline: '工艺资料与交付协作',
    loginIntro: '查看品牌发出的工艺资料，确认交货计划，留存协作记录。',
    supplierLogin: '供应商登录',
    authorizedAccess: '仅限已授权供应商访问',
    documents: '工艺资料',
    documentsDetail: '按款号与版本查看工艺单及原始文件',
    delivery: '交付计划',
    deliveryDetail: '确认工厂发货日期，明确交付安排',
    records: '确认记录',
    recordsDetail: '集中查看资料确认状态与修改意见',

    plannedShipDate: '计划发货日期',
    shipDatePlaceholder: '请选择工厂计划发货日期',
    shipDateRequired: '确认时请填写工厂计划发货日期。',
    shipDateInvalid: '请输入有效的计划发货日期。',

    availableQuantity: '工厂可供数量',
    originalQuantity: '原订货 {n}',
    quantityInvalid: '数量必须为非负整数，且只能调整本单已有颜色尺码。',
    quantityAdjusted: '数量已调整，待内部核对',
    orderQuantity: '订货数量',
    quantityBreakdown: '颜色尺码数量明细',
    quantityUnavailable: '暂无颜色尺码数量',
    quantityConfirmed: '数量及资料已确认',
    orderRequestDate: '订单申请日期',
    viewPack: '查看工艺单',
    confirmPack: '工厂确认',
    contents: '工艺单目录',
    attachments: '附件',
    confirmationTitle: '工厂确认',
    confirmationHint: '请核对本次发送的工艺单、订货数量及入库要求日期后提交。',
    versionLabel: '版本 V{n}',
    pieces: '{n} 件',
    confirmAction: '确认本次资料',
    requestDateHelp: '订单申请日期为生产管理确认发给工厂的时间。',

    landscapePreview: '工艺单预览（A4 横向）',
    sourceFiles: '原始文件下载',
    downloadOriginal: '下载原文件',
    attachedSources: '将随单发送的源文件',
    sourceVersionHint: '以下文件保留本次发送时的版本。后续补充或替换的文件需由生产管理重新发送。',
    portalTitle: '供应商协作平台',
    portalLoginHint: '使用生产管理提供的工厂联系人账号登录，查看发给您的工艺单。',
    inboxTitle: '收到的工艺单',
    inboxEmpty: '暂无可查看的工艺单，请联系生产管理确认是否已发送。',
    inboxSearch: '搜索款号或品名',
    inboxTotal: '共 {n} 批资料',
    backInbox: '返回收到的工艺单',
    selectReply: '请选择确认结果',
    portalVersion: '工艺单版本号',
    generatedAt: '生成时间',
    previewFactory: '预览工厂资料',
    chooseRecipient: '选择工厂与联系人',
    linkReady: '确认链接',
    previewHelp: '先核对工厂将看到的资料，再选择加工厂和联系人。',
    reviewAndContinue: '确认预览，选择接收人',
    backToPreview: '返回预览',
    previewChanged:'预览后的资料已有变化，请重新预览并核对后再发布。',
    excelRoundTripHint: '一键复制整表到 Excel，填写后连同表头与序号全选复制，回到此表按 Ctrl+V。只读列请保持原样；调整行顺序或表格变化后请重新复制。',
    dragRow: '拖动序号调整顺序（或按上下方向键）',
    confirmBeforeSend: '完成最终资料核对',
    markSent: "发布到供应商平台",
    deliveryHelp: '生成链接后，请交给工厂联系人，再确认已发送。确认前，本款仍保留在生产待办中。',
    deliveryRecorded: '已记录发厂，工厂可登录核对本次资料。',
    generatedOnly: "资料尚未发布到供应商平台",
    linkCreatedAt: '链接生成时间',

    supplierMissing:"请先填写本款的加工厂 / 供应商。新建联系人不会自动指定本款加工厂。",
    noSupplierContact:"没有与「{supplier}」匹配的在用联系人，请核对联系人所属供应商。",
    noBrandContact:"该供应商的在用联系人尚未获授权接收所选品牌：{brands}。",
    editSupplier:"修改供应商",
    saveSupplier:"保存供应商",
    supplierSaved:"供应商已保存",
    supplierHelp:"由生产管理选择本款加工厂。更改供应商后需重新核对最终 Tech Pack。",
    refreshContacts:"刷新联系人",
    pendingBeforeSend:"发送前请完成以下事项",
    reviewSheet:"返回资料核对",
    commentRequired:'请填写需要修改的内容。',usernameUsed:'该账号已使用，请换一个账号。',loginFailed:'账号或密码不正确，或账号已停用。',loginLimited:'登录尝试过于频繁，请15分钟后再试。',loadFailed:'资料加载失败，请稍后重试。',replyChanged:'核对结果已更新，请刷新后重新核对。',openLink:"请登录供应商平台查看已收到的工艺单。",imageFailed:'部分图片加载失败，请刷新后重新核对。导出需等待全部图片加载。',copyNow:"可复制平台资料入口，收件联系人登录后查看。",currentCopy:'与当前资料一致',usernameHint:'账号使用3–80位小写英文字母、数字、点、下划线或短横线。',resetConfirm:'重设密码会使该联系人当前登录失效。是否继续？',disableConfirm:'停用后，该联系人不能再登录或查看确认资料。是否继续？',enableConfirm:'是否恢复该联系人账号？',enable:'启用账号',colorChoice:'配色',tooLarge:'本批资料文件超过500MB，请减少款式或附件后分批发送。',columnCount:'复制列数',productionBatch:'生产批次',completion:'我的完成确认',collaboration:'协作进度',emptyCompletion:'当前没有需你确认的事项',otherChanges:'资料调整',imageLayout:'图片分类与排序',pictures:'图片资料',reference:'参考款资料',supplier:'加工厂 / 供应商',accounts:'工厂联系人账号',factory:'工厂确认',send:'发送给工厂',batch:'工厂资料发送',selectAccount:'选择工厂联系人',copyLink:"复制平台资料入口",createLink:"发布到供应商平台",copyDone:'已复制',copyFailed:'无法读取剪贴板，请手动复制',autoColumns:'自动列宽',resizeColumn:'调整此列宽度',copyTable:'复制表格到 Excel',pasteTable:'粘贴表格',pasteHint:'从 Excel 复制单元格，选择起始位置。复制内容不含表头；粘贴时也不要选表头。先预览再应用，不增加或删除已有行。',startRow:'起始行',startColumn:'起始列',pasteInput:'粘贴 Excel 单元格',preview:'预览',apply:'应用表格',pasteReady:'将更新 {n} 个单元格',pasteChanged:'内容已改变，请重新预览',column:'第 {n} 列',row:'第 {n} 行',code:'编号',contact:'联系人',username:'登录账号',password:'密码',login:'登录',logout:'退出',reviewed:'已确认',changesNeeded:'需要修改',comment:'确认意见',confirm:'提交确认结果',received:'确认结果已记录',expired:"资料已撤回或无权查看，请联系生产管理",brand:'品牌',createAccount:'新增联系人',disabled:'已停用',active:'在用',temporaryPassword:'初始密码仅显示一次，请妥善交给联系人',resetPassword:'重设密码',selectSupplier:'选择供应商',selected:'已选择 {n} 款',downloadBatch:'批量导出 PDF',sendBatch:'批量发布给工厂',sentAt:'发送时间',expiresAt:'有效期至',revoked:'已撤回',revoke:"撤回资料",revision:'发送版本',status:'工厂确认状态',unconfirmed:'待确认',noSupplier:'尚未填写供应商',noRows:'没有符合条件的款式',needConfirmed:'请先完成内部 Tech Pack 核对',sameSupplier:'一次只能发送同一家供应商的款式',linkHelp:"请登录供应商账号核对资料。确认结果不代表生产放行。",readonly:'资料为发送时的版本，后续修改请联系生产管理重新发送。',access:'查看资料',accountName:'联系人姓名',accountBrand:'可接收品牌',accountSupplier:'所属供应商',save:'保存',cancel:'取消',loading:'正在准备资料…',accountUnavailable:'账号不可用或资料不在授权范围内',internalStatus:'内部核对',final:'Tech Pack 最终核对',dataChanged:'资料已有新修改，请重新发送最新版本',file:'资料文件',download:'下载',remove:'停用账号',expires:'链接有效期（天）',sendConfirm:'将所选款式发布到供应商平台',revokeConfirm:'撤回后工厂将无法继续访问这次资料。',list:'已发送资料',details:'查看本次资料',done:'已完成',pending:'待完成'},
};
